function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  className: "st0",
  d: "M10,0.5c-0.5,0-0.9,0-1.4,0.1c-2.8,0.5-5,2.8-5.5,5.5c-0.5,2.6,0.5,5,2.2,6.6 C5.8,13.1,6,13.6,6,14.2v2.3c0,1.1,0.9,2,2,2h0.3c0.4,0.6,1,1,1.7,1s1.4-0.4,1.7-1H12c1.1,0,2-0.9,2-2v-2.3c0-0.5,0.2-1.1,0.6-1.5 c1.4-1.3,2.4-3.1,2.4-5.2C17,3.6,13.9,0.5,10,0.5z M12,14.5H8v-1h4V14.5z M8,16.5v-1h4v1H8z M13.3,11.2c-0.1,0.1-0.2,0.2-0.2,0.3 H6.9c-0.1-0.1-0.2-0.2-0.2-0.3C5.4,10,4.8,8.3,5.1,6.5C5.5,4.6,7.1,3,9,2.6c0.3-0.1,0.7-0.1,1-0.1c2.8,0,5,2.2,5,5 C15,8.9,14.4,10.3,13.3,11.2z"
});

var SvgManualTips = function SvgManualTips(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgManualTips, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/manual_tips.63c3c02a.svg";
export { ForwardRef as ReactComponent };